/**
 * Lotus CDN provider icons (dmcegeg7oly4.cloudfront.net/m/cp/v2/{base64}.webp).
 * Keys are lowercase lookup names; values are exact CDN filenames (base64 segment).
 */
export const LOTUS_PROVIDER_ICON_B64: Record<string, string> = {
  evolution: 'ZXZvbHV0aW9u',
  'evolution live': 'ZXZvbHV0aW9u',
  turbogames: 'dHVyYm9nYW1lcw==',
  'mac88 gaming': 'bWFjODhHYW1pbmc=',
  mac88: 'bWFjODhHYW1pbmc=',
  'mac88gaming': 'bWFjODhHYW1pbmc=',
  'topspin games': 'dG9wU3BpbkdhbWVz',
  topspin: 'dG9wU3BpbkdhbWVz',
  ezugi: 'ZXp1Z2k=',
  '155.io': 'MTU1Lmlv',
  'betgames.tv': 'YmV0R2FtZXMuVFY=',
  betgames: 'YmV0R2FtZXMuVFY=',
  betsoft: 'YmV0c29mdA==',
  bgaming: 'YkdhbWluZw==',
  'booming games': 'Ym9vbWluZ0dhbWVz',
  booming: 'Ym9vbWluZ0dhbWVz',
  fugaso: 'ZnVnYXNv',
  'hacksaw gaming': 'aGFja3Nhd0dhbWluZw==',
  hacksaw: 'aGFja3Nhd0dhbWluZw==',
  'mac88 gaming virtual': 'bWFjODhHYW1pbmdWaXJ0dWFs',
  onetouch: 'b25lVG91Y2g=',
  onlyplay: 'b25seXBsYXk=',
  playson: 'cGxheXNvbg==',
  smartsoft: 'c21hcnRTb2Z0',
  'smartsoft gaming': 'c21hcnRTb2Z0',
  spribe: 'c3ByaWJl',
  tristar: 'dHJpU3Rhcg==',
  voltent: 'dm9sdEVudA==',
  winfast: 'd2luRmFzdA==',
  playtech: 'cGxheXRlY2g=',
  jili: 'amlsaQ==',
  netent: 'bmV0ZW50',
  redtiger: 'cmVkdGlnZXI=',
  'red tiger': 'cmVkdGlnZXI=',
  pragmatic: 'cHJhZ21hdGlj',
  'pragmatic play': 'cHJhZ21hdGlj',
  '100hp': 'MTAwaHA=',
  '2j': 'Mmo=',
  '5ggaming': 'NWdHYW1pbmc=',
}

const CDN_BASE = 'https://dmcegeg7oly4.cloudfront.net/m/cp/v2'

function toCamelCaseName(name: string): string {
  const parts = name.trim().split(/[\s_-]+/).filter(Boolean)
  if (parts.length === 0) return name
  return parts
    .map((p, i) =>
      i === 0 ? p.charAt(0).toLowerCase() + p.slice(1) : p.charAt(0).toUpperCase() + p.slice(1),
    )
    .join('')
}

function b64(s: string): string {
  try {
    return btoa(unescape(encodeURIComponent(s)))
  } catch {
    return ''
  }
}

/** Ordered CDN + local candidates for a provider display/API name. */
export function getLotusProviderIconCandidates(name: string, localSlug?: string): string[] {
  const raw = (name || '').trim()
  const lower = raw.toLowerCase()
  const noSpace = lower.replace(/\s+/g, '')
  const camel = toCamelCaseName(raw)
  const out: string[] = []

  const push = (url: string) => {
    if (url && !out.includes(url)) out.push(url)
  }

  /* Prefer locally downloaded CDN copies when present */
  const localCdnSlug = localSlug || noSpace
  push(`/imgs/game_providers/cdn/${localCdnSlug}.webp`)
  if (localSlug && localSlug !== noSpace) push(`/imgs/game_providers/cdn/${noSpace}.webp`)

  const mapped = LOTUS_PROVIDER_ICON_B64[lower] || LOTUS_PROVIDER_ICON_B64[noSpace]
  if (mapped) push(`${CDN_BASE}/${mapped}.webp`)

  for (const variant of [raw, lower, noSpace, camel]) {
    const enc = b64(variant)
    if (enc) push(`${CDN_BASE}/${enc}.webp`)
  }

  if (localSlug) {
    push(`/imgs/game_providers/${localSlug}.svg`)
    push(`/game_providers/${localSlug}.svg`)
  }
  push(`/imgs/game_providers/${noSpace}.svg`)
  push(`/game_providers/${noSpace}.svg`)

  return out
}

export function getLotusProviderIconUrl(name: string, localSlug?: string): string {
  return getLotusProviderIconCandidates(name, localSlug)[0] || ''
}
